"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuListItemExtended;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _Title = _interopRequireDefault(require("./Title"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Space = _interopRequireDefault(require("./Space"));
var _Description = _interopRequireDefault(require("./Description"));
var _excluded = ["label", "description", "action", "style", "children", "titleStyle", "descriptionStyle", "anchorStyle"];
var SPACING = 24;
function MenuListItemExtended(props) {
  var label = props.label,
    description = props.description,
    action = props.action,
    style = props.style,
    children = props.children,
    titleStyle = props.titleStyle,
    descriptionStyle = props.descriptionStyle,
    anchorStyle = props.anchorStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: [style, styles.container]
  }, rest), /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: [styles.label, titleStyle]
  }, label), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Description["default"], {
    style: descriptionStyle
  }, description), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), children, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Anchor["default"], {
    style: [styles.anchor, anchorStyle],
    title: action
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    paddingTop: SPACING / 2,
    paddingBottom: SPACING / 2
  },
  label: {
    fontSize: 19,
    color: _styles.colors.common,
    textAlign: 'left'
  },
  anchor: {
    color: _styles.colors.focus,
    lineHeight: 24
  }
});